import React from "react";

/**
 * Solid disc with the "i" knocked out through fill-rule="evenodd", drawn entirely in currentColor.
 *
 * That single-colour construction is what keeps it legible on any background: on a light row it is
 * a coloured disc, and on a filled/selected row it inverts to a light disc with the row's own
 * colour showing through the glyph. A stroked outline was too faint to notice, and a two-tone icon
 * disappears against a dark selection.
 *
 * Inline rather than an svg asset in images/ so it inherits colour and hover state; a
 * background-image icon needs a second file per colour.
 */
function InfoIcon({ size = 18 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5Zm0 3.05a1.32 1.32 0 1 1 0 2.64 1.32 1.32 0 0 1 0-2.64ZM8.83 8.62a1.17 1.17 0 0 1 2.34 0v5.98a1.17 1.17 0 0 1-2.34 0V8.62Z"
      />
    </svg>
  );
}

export default InfoIcon;
